import { defineComponent as _defineComponent } from 'vue'
import { computed, useAsync, useRouter, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useAuth } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";
import { getLtksStore } from "@/store/ltks";
import { getProductsStore } from "@/store/products";
import { getWishlistsStore } from "@/store/wishlists";
import { hasValidTooltipReferral } from "@/utils/sessionstorage";
import { TOOLTIP_REFERRER_POST_PAGE_LIKE_TIMESTAMP } from "@/utils/sessionstorage/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkProductLike',
  props: {
  ltkProductId: { type: String, required: true },
  referringComponent: { type: String, default: "" },
  isRunway: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;



const amplitude = useAmplitude();
const auth = useAuth();
const router = useRouter();
const store = useStore();

const fetch = () => {
  if (auth.loggedIn) {
    getWishlistsStore(store).fetchWishById(props.ltkProductId);
  }
};

const getReferringComponent = (): string => {
  if (hasValidTooltipReferral(TOOLTIP_REFERRER_POST_PAGE_LIKE_TIMESTAMP)) {
    return "post page - like product tooltip";
  }
  return props.referringComponent;
};

const onFavoriteChange = async () => {
  const wishlistsStore = getWishlistsStore(store);
  const prodId = props.ltkProductId;

  if (auth.loggedIn) {
    const ltkStore = getLtksStore(store);

    const ltkId = getProductsStore(store).products[prodId]?.ltkId ?? "";
    const products = ltkStore.ltks[ltkId]?.productIds;

    const payload: LtKFavoriteProps = {
      "ltk-id": ltkId,
      "profile-id": ltkStore.ltks[ltkId]?.profileId || "",
      "ltk-product-id": prodId,
      "content-type": "product",
      "referring-component": props.referringComponent,
      count: products?.length,
      index: products?.indexOf(prodId),
    };

    if (isProductLiked.value) {
      await wishlistsStore.removeWish({ ltkProductId: prodId });
      amplitude?.sendEvent("/unwish", payload);
    } else {
      wishlistsStore.addWish({ ltkProductId: prodId });
      amplitude?.sendEvent("/wish", payload);
    }
  } else {
    localStorage.setItem("favorite-product", prodId);
    wishlistsStore.setLoggedOutFavLtkProductId(prodId);
    getAmplitudeStore(store).setReferringComponent(getReferringComponent());
    router.push({ path: "/signup", query: { "shopltk-signup-prompt": "favorite-product" } });
  }
};

const isProductLiked = computed(() => Boolean(getWishlistsStore(store).getWishIdByLtkProductId(props.ltkProductId)));

useAsync(() => fetch(), "LtkProductLike Fetch");

return { __sfc: true,props, amplitude, auth, router, store, fetch, getReferringComponent, onFavoriteChange, isProductLiked }
}

})